import request from '../../../../../util/APIUtils';
import { PORTAL_API_BASE_URL } from '../../../../../constants';
import { ATTACHMENT_INSTANCE_TYPE } from './attachment.constants';

const contentAttachmentUrl = `${PORTAL_API_BASE_URL}/api/content/attachment`;

const buildWidgetAttachmentsUrl = (casePlanId, widgetId) =>
  `${PORTAL_API_BASE_URL}/api/admin/case-plan/${casePlanId}/widgets/${widgetId}/attachments`;

/**
 * POST /api/content/attachment/presigned-urls
 * @param {string} widgetId
 * @param {{ filename: string, fileSize: number, mimeType: string }[]} files
 */
export const requestAttachmentPresignedUrls = (widgetId, files) =>
  request({
    url: `${contentAttachmentUrl}/presigned-urls`,
    method: 'POST',
    body: JSON.stringify({
      instanceType: ATTACHMENT_INSTANCE_TYPE,
      instanceId: widgetId,
      files,
    }),
    suppressErrorToast: true,
    throw400Error: true,
  });

/**
 * GET /api/content/attachment/:id/download-url
 * @param {string} attachmentId
 */
export const fetchAttachmentDownloadUrl = (attachmentId) =>
  request({
    url: `${contentAttachmentUrl}/${attachmentId}/download-url`,
    method: 'GET',
    suppressErrorToast: true,
  });

/**
 * POST /api/admin/case-plan/:planId/widgets/:widgetId/attachments
 * @param {string} casePlanId
 * @param {string} widgetId
 * @param {{ id: string, filename: string, fileSize: number, mimeType: string }[]} attachments
 */
export const commitWidgetAttachments = (casePlanId, widgetId, attachments) =>
  request({
    url: buildWidgetAttachmentsUrl(casePlanId, widgetId),
    method: 'POST',
    body: JSON.stringify({ attachments }),
    suppressErrorToast: true,
    throw400Error: true,
  });

/**
 * DELETE /api/admin/case-plan/:planId/widgets/:widgetId/attachments/:attachmentId
 * @param {string} casePlanId
 * @param {string} widgetId
 * @param {string} attachmentId
 */
export const unlinkWidgetAttachment = (casePlanId, widgetId, attachmentId) =>
  request({
    url: `${buildWidgetAttachmentsUrl(casePlanId, widgetId)}/${attachmentId}`,
    method: 'DELETE',
    suppressErrorToast: true,
  });

/**
 * PUT a file to an S3 presigned upload URL. Does not send the app auth header.
 * @param {{ uploadUrl: string, file: File, mimeType?: string }} params
 */
export const uploadFileToPresignedUrl = async ({ uploadUrl, file, mimeType }) => {
  if (!uploadUrl || !file) {
    throw new Error('Missing required upload data.');
  }

  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': mimeType || file.type || 'application/octet-stream',
    },
    body: file,
  });

  if (!response.ok) {
    throw new Error(`Upload failed for "${file?.name || 'file'}".`);
  }

  return response;
};
